/* ========================================================================
   FILE: src/index.js (CUSTOM ORDER: TRUST -> BITGET -> OKX -> DLL)
   ======================================================================== */
import './fixError';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultConfig,
  RainbowKitProvider,
  darkTheme,
  connectorsForWallets,
} from '@rainbow-me/rainbowkit';

// IMPORT WALLET
import {
  trustWallet,
  bitgetWallet,
  okxWallet,
  metaMaskWallet,
  coinbaseWallet,
  injectedWallet,   // Browser Wallet
  walletConnectWallet,
  binanceWallet,
} from '@rainbow-me/rainbowkit/wallets';

import { WagmiProvider } from 'wagmi';
// IMPORT JARINGAN EVM LENGKAP
import { bsc, mainnet, base, polygon, arbitrum, optimism, avalanche } from 'wagmi/chains';
import { http } from 'wagmi';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient();

// --- CONFIG URUTAN WALLET (TRUST -> BITGET -> OKX -> DLL) ---
const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        trustWallet,        // 1. Trust Wallet (Prioritas)
        bitgetWallet,       // 2. Bitget Wallet
        okxWallet,          // 3. OKX Wallet
        metaMaskWallet,     // 4. MetaMask
        coinbaseWallet,     // 5. Coinbase Wallet
        injectedWallet,     // 6. Browser/Injected Wallet
        walletConnectWallet,// 7. WalletConnect
        binanceWallet,      // 8. Binance Wallet
      ],
    },
  ],
  {
    appName: 'Warden Airdrop',
    projectId: '97c5fe781f2d1ea94fc8dbda7f27ceb6', 
  }
);

// --- CONFIG WAGMI ---
const config = getDefaultConfig({
  appName: 'Warden Airdrop',
  projectId: 'cmlf8dp3q02jojs0cqnqdjk1b',
  
  chains: [bsc, mainnet, base, polygon, arbitrum, optimism, avalanche],
  
  transports: {
    [bsc.id]: http('https://late-wider-replica.bsc.quiknode.pro/91ef176d84c3eac2171ac728f1f1158cd99ec5d4/'),
    [mainnet.id]: http('https://rpc.ankr.com/eth/f2c4a86b8ceea115bf274428a70bea63770c621d24a9bb149e92640df04e41ae'),
    [base.id]: http('https://rpc.ankr.com/base/f2c4a86b8ceea115bf274428a70bea63770c621d24a9bb149e92640df04e41ae'),
    [polygon.id]: http('https://rpc.ankr.com/polygon/f2c4a86b8ceea115bf274428a70bea63770c621d24a9bb149e92640df04e41ae'),
    [arbitrum.id]: http('https://rpc.ankr.com/arbitrum/f2c4a86b8ceea115bf274428a70bea63770c621d24a9bb149e92640df04e41ae'),
    [optimism.id]: http('https://api.zan.top/node/v1/opt/mainnet/179fd339ff7a43caacd28ac57b233555'),
    [avalanche.id]: http('https://rpc.ankr.com/avalanche/f2c4a86b8ceea115bf274428a70bea63770c621d24a9bb149e92640df04e41ae'),
  },
  
  connectors,
  ssr: true, 
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider 
            theme={darkTheme({
                accentColor: '#bef264',
                accentColorForeground: 'black',
                borderRadius: 'large',
            })}
            initialChain={bsc}
        >
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);